import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import CustomModal from "./CustomModel";
import PageLoader from "./PageLoader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const DoctorAttendance = () => {
     const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
     const token = localStorage.getItem('jwt_token');
     const [attendanceRecords, setAttendanceRecords] = useState([]);
     const [hoveredDate, setHoveredDate] = useState(null);
     const [doctorBMID, setDoctorBMID] = useState("");
     const [hoveredDoctor, setHoveredDoctor] = useState(null);
     const [doctorDetails, setDoctorDetails] = useState(null);
     const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });
     const [month, setMonth] = useState("");
     const [showAddModal, setShowAddModal] = useState(false);
     const [showEditModal, setShowEditModal] = useState(false);
     const [loading, setLoading] = useState(false);
     const [currentPage, setCurrentPage] = useState(1);
     const [pageSize, setPageSize] = useState(50); // default 10 per page
     const [totalPages, setTotalPages] = useState(1);
     const [formData, setFormData] = useState({
          doct_code: '',
          month: new Date().toISOString().slice(0, 7), // format: "YYYY-MM"          
          in_time: '',
          out_time: '',
          date: ''
     });
     const openEditModal = (record) => {
          setFormData({
               id: record.id,
               doct_code: record.doct_code,
               date: record.date,
               in_time: record.in_time.slice(11, 16), // extract "HH:mm"
               out_time: record.out_time.slice(11, 16),
               month: `${record.year}-${record.month.padStart(2, '0')}`
          });
          setShowEditModal(true);
     };
     useEffect(() => {
          const currentMonth = new Date().toISOString().slice(0, 7);
          setMonth(currentMonth);
          // fetchAttendanceRecords();
     }, []);
     useEffect(() => {
          fetchAttendanceRecords(formData.doct_code, formData.month);
     }, [formData.doct_code, formData.month]);
     const fetchAttendanceRecords = async (doct_code, month) => {
          setLoading(true);
          try {
               const response = await fetch(`${API_BASE_URL}api/doctor_attendance`, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                         doct_code: formData.doct_code,
                         month: formData.month,
                    }),
               });
               const data = await response.json();
               setAttendanceRecords(data.data || []);
          } catch (error) {
               console.error("Error fetching attendance records:", error);
          } finally {
               setLoading();
          }
     };
     const indexOfLastRecord = currentPage * pageSize;
     const indexOfFirstRecord = indexOfLastRecord - pageSize;
     const currentRecords = attendanceRecords.slice(indexOfFirstRecord, indexOfLastRecord);
     const handleInputChange = (e) => {
          const { name, value } = e.target;
          setFormData((prevFormData) => ({
               ...prevFormData,
               [name]: value
          }));
     };
     useEffect(() => {
          const pages = Math.ceil(attendanceRecords.length / pageSize) || 1;
          setTotalPages(pages);
          if (currentPage > pages) {
               setCurrentPage(1); // reset if page out of range
          }
     }, [attendanceRecords]);
     const handleBlur = () => {
          fetchAttendanceRecords(formData.doct_code, formData.month);
     };
     const getTimeDiff = (inTime, outTime) => {
          const inDate = new Date(`1970-01-01T${inTime}`);
          const outDate = new Date(`1970-01-01T${outTime}`);
          const diff = new Date(outDate - inDate);
          const hours = String(diff.getUTCHours()).padStart(2, '0');
          const minutes = String(diff.getUTCMinutes()).padStart(2, '0');
          const seconds = String(diff.getUTCSeconds()).padStart(2, '0');
          return `${hours}.${minutes}.${seconds}`;
     };
     const handleAddAttendance = async (e) => {
          e?.preventDefault?.();
          const { doct_code, date, in_time, out_time } = formData;
          if (!doct_code || !date || !in_time || !out_time) {
               alert("All fields are required");
               return;
          }
          const dateObj = new Date(date);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const time = getTimeDiff(in_time, out_time); // assume implemented
          const payload = {
               doct_code,
               date,
               in_time,
               out_time,
               year,
               month,
               time
          };
          try {
               const response = await fetch(`${API_BASE_URL}api/doctor_attendance_create`, {
                    method: "POST",
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload)
               });
               if (!response.ok) throw new Error("Failed to add attendance");
               const result = await response.json();
               alert("Attendance added successfully!");
               // ✅ Close modal
               setShowAddModal(false);
               // ✅ Only clear modal-specific fields, NOT doct_code or month
               setFormData((prev) => ({
                    ...prev,
                    in_time: '',
                    out_time: '',
                    date: ''
               }));
               // ✅ Use already known values to refresh
               const formattedMonth = `${year}-${month}`;
               fetchAttendanceRecords(doct_code, formattedMonth);
          } catch (error) {
               console.error("Error adding attendance:", error);
               alert("Add failed");
          }
     };

     const handleEditAttendance = async (e) => {
          e.preventDefault();
          const { doct_code, date, in_time, out_time } = formData;
          if (!doct_code || !date || !in_time || !out_time) {
               alert("All fields are required");
               return;
          }
          const dateObj = new Date(date);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const time = getTimeDiff(in_time, out_time); // existing helper
          const payload = {
               doct_code,
               date,
               in_time,
               out_time,
               year,
               month,
               time
          };
          try {
               const response = await fetch(`${API_BASE_URL}api/doctor_attendance_edit/${formData.id}`, {
                    method: "POST",
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload)
               });
               if (!response.ok) throw new Error("Failed to update attendance");
               alert("Attendance updated successfully!");
               setShowEditModal(false);
               fetchAttendanceRecords(doct_code, `${year}-${month}`); // refresh view
          } catch (error) {
               console.error("Edit failed:", error);
               alert("Failed to update attendance");
          }
     };
     const handleDeleteAttendance = async (id) => {
          const confirmDelete = window.confirm("Are you sure you want to delete this attendance record?");
          if (!confirmDelete) return;
          try {
               const response = await fetch(`${API_BASE_URL}api/doctor_attendance_delete/${id}`, {
                    method: "POST", // or "DELETE" if your backend supports it
                    headers: {
                         'Authorization': `Bearer ${token}`, // if required
                    },
               });
               if (!response.ok) {
                    throw new Error("Failed to delete attendance");
               }
               alert("Attendance deleted successfully!");
               fetchAttendanceRecords(); // refresh after delete
          } catch (error) {
               console.error("Error deleting attendance:", error);
               alert("Error deleting attendance");
          }
     };

    const exportToExcel = () => {
  // Format and reorder attendance data
  const formattedData = attendanceRecords.map((record) => ({
    doct_code: record.doct_code || '',
    comp_name: record.comp_name || '', // moved beside doct_code

    in_time: record.in_time
      ? new Date(record.in_time).toLocaleTimeString('en-GB', { hour12: false })
      : '',
    out_time: record.out_time
      ? new Date(record.out_time).toLocaleTimeString('en-GB', { hour12: false })
      : '',
    time: record.time || '',
    month: record.month || '',
    year: record.year || '',
    date: record.date || '',
//     remarks: record.remarks || '',
    // add other fields below if needed
  }));

  // Convert formatted data to a sheet
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // Create a workbook and append the sheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Report");

  // Create Excel file buffer
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // Save file
  const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(fileData, `attendance_report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};



     const getTotalDutyHours = (records = []) => {
          if (!Array.isArray(records) || records.length === 0) {
               return "00:00:00";
          }

          let totalSeconds = 0;

          records.forEach(record => {
               if (record.time) {
                    const [h, m, s] = record.time.split(".").map(Number);
                    totalSeconds += (h * 3600) + (m * 60) + s;
               }
          });

          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
     };

     useEffect(() => {
          if (hoveredDoctor && hoveredDate) {
               const fetchDoctor = async () => {
                    try {
                         const res = await fetch(
                              `${API_BASE_URL}api/getDoctorAttendanceDetails/${hoveredDoctor}/${hoveredDate}`,
                              {
                                   method: "GET",
                                   headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${token}`,
                                   },
                              }
                         );

                         if (!res.ok) {
                              throw new Error(`HTTP error! Status: ${res.status}`);
                         }

                         const data = await res.json();
                         setDoctorDetails(data.data); // <- API has {STATUS, message, data}
                    } catch (err) {
                         console.error("Error fetching doctor details:", err);
                    }
               };

               fetchDoctor();
          } else {
               setDoctorDetails(null);
          }
     }, [hoveredDoctor, hoveredDate, token]);





     return (
          <div className="wrapper">
               <Sidebar />
               <main className="main-content content-page">
                    <div className="position-relative">
                         <Navbar />
                    </div>
                    <div className="content-inner container-fluid pb-0" id="page_layout">
                         <div className="row">
                              <div className="col-sm-12">
                                   {loading && <PageLoader />}
                                   <div className="card">
                                        <div className="row m-2">
                                             <div className="col-sm-3">
                                                  <input
                                                       name="doct_code"
                                                       value={formData.doct_code}
                                                       onChange={handleInputChange}
                                                       className="form-control form-control-sm"
                                                       placeHolder="Doctor BMID"
                                                       onBlur={handleBlur}
                                                  />
                                             </div>
                                             <div className="col-sm-3">
                                                  <input
                                                       type="month"
                                                       name="month"
                                                       value={formData.month}
                                                       onChange={handleInputChange}
                                                       className="form-control form-control-sm"
                                                  />
                                             </div>
                                             <div className="col-sm-3">
                                                  <button
                                                       className="btn btn-sm btn-info"
                                                       onClick={() => setShowAddModal(true)}
                                                  >
                                                       Add New Attendance
                                                  </button>
                                             </div>
                                             <div className="col-sm-1">
                                                  <select
                                                       className="form-select form-select-sm w-auto d-inline-block"
                                                       value={pageSize}
                                                       onChange={(e) => {
                                                            setCurrentPage(1);
                                                            setPageSize(parseInt(e.target.value));
                                                       }}
                                                  >
                                                       <option value={5}>5</option>
                                                       <option value={10}>10</option>
                                                       <option value={25}>25</option>
                                                       <option value={50}>50</option>
                                                  </select>
                                             </div>
                                             <div className="col-sm-2">
                                                  <button className="btn btn-success mb-2" onClick={exportToExcel}>
                                                       Export to Excel
                                                  </button></div>
                                        </div>
                                        <div className="row m-2">
                                             <div className="col-sm-12 mt-3">
                                                  <table className="table table-responsive">
                                                       <thead>
                                                            <tr>
                                                                 <th>Date</th>
                                                                 {/* <th>Name</th> */}
                                                                 <th>BMID</th>
                                                                 <th>In Time</th>
                                                                 <th>Out Time</th>
                                                                 <th>Duty Hours</th>
                                                                 <th>Action</th>
                                                            </tr>
                                                       </thead>
                                                       <tbody>
                                                            {currentRecords.map((record) => (
                                                                 <tr key={record.id}>
                                                                      <td>{record.date}</td>
                                                                      {/* <td>{record.comp_name}</td> */}
                                                                      <td
                                                                           onClick={(e) => {
                                                                                setHoveredDoctor(record.doct_code);   // doctor code
                                                                                setHoveredDate(record.date);          // capture the date
                                                                                setPopupPos({ x: e.clientX, y: e.clientY });
                                                                           }}
                                                                           style={{ cursor: "pointer", color: "blue" }}
                                                                      >
                                                                           {record.doct_code}
                                                                      </td>
                                                                      <td>{record.in_time}</td>
                                                                      <td>{record.out_time}</td>
                                                                      <td>{record.time}</td>
                                                                      <td>
                                                                           <button
                                                                                className="btn btn-sm btn-info mr-2"
                                                                                onClick={() => openEditModal(record)}
                                                                           >
                                                                                <i
                                                                                     className="ri-pencil-fill mr-2"
                                                                                     data-bs-toggle="tooltip"
                                                                                     title="Edit"
                                                                                     data-bs-placement="right"
                                                                                ></i>
                                                                           </button>
                                                                           {/* <button
                                                                                className="btn btn-sm btn-danger ml-2"
                                                                                onClick={() => handleDeleteAttendance(record.id)}
                                                                           >
                                                                                <i class="ri-delete-bin-fill"></i>
                                                                           </button> */}
                                                                      </td>
                                                                 </tr>
                                                            ))}
                                                       </tbody>
                                                       <tfoot>
                                                            <tr>
                                                                 <td colSpan="4">Total</td>
                                                                 <td>{getTotalDutyHours(currentRecords)}</td>
                                                                 <td></td>
                                                            </tr>
                                                       </tfoot>
                                                  </table>
                                                  {hoveredDoctor && doctorDetails && (
                                                       <div
                                                            style={{
                                                                 position: "fixed",
                                                                 top: popupPos.y + 10,
                                                                 left: popupPos.x + 10,
                                                                 background: "white",
                                                                 border: "2px solid #007bff",
                                                                 borderRadius: "10px",
                                                                 padding: "20px",
                                                                 boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                                                 zIndex: 999,
                                                                 fontSize: "16px",
                                                                 lineHeight: "1.8",
                                                                 minWidth: "280px",
                                                            }}
                                                       >
                                                            {/* Header with Close Button */}
                                                            <div
                                                                 style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                      alignItems: "center",
                                                                      marginBottom: "10px",
                                                                 }}
                                                            >
                                                                 <div style={{ fontSize: "18px", fontWeight: "bold", color: "#007bff" }}>
                                                                      Doctor Attendance Details
                                                                 </div>
                                                                 <button
                                                                      onClick={() => setHoveredDoctor(null)} // 👈 closes the popup

                                                                 >
                                                                      close
                                                                 </button>
                                                            </div>

                                                            <strong>Doctor Code:</strong> {doctorDetails.doct_code} <br />
                                                            <strong>Attendance Date:</strong> {doctorDetails.attendance_date} <br />
                                                            <strong>Old In:</strong> {doctorDetails.old_in_time} <br />
                                                            <strong>Old Out:</strong> {doctorDetails.old_out_time} <br />
                                                            <strong>New In:</strong> {doctorDetails.new_in_time} <br />
                                                            <strong>New Out:</strong> {doctorDetails.new_out_time} <br />
                                                            <strong>Updated By:</strong> {doctorDetails.updated_by}
                                                       </div>
                                                  )}



                                                  <div className="row">
                                                       <div className="col-sm-3 mt-2 text-muted">
                                                            Showing {(currentPage - 1) * pageSize + 1} to{" "}
                                                            {Math.min(currentPage * pageSize, attendanceRecords.length)} of{" "}
                                                            {attendanceRecords.length} entries
                                                       </div>
                                                       <div className="col-sm-9 d-flex justify-content-between align-items-center mt-3">
                                                            <button
                                                                 className="btn btn-sm btn-outline-secondary"
                                                                 disabled={currentPage === 1}
                                                                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                            >
                                                                 ⬅️ Previous
                                                            </button>
                                                            <span>Page {currentPage} of {totalPages}</span>
                                                            <button
                                                                 className="btn btn-sm btn-outline-secondary"
                                                                 disabled={currentPage === totalPages}
                                                                 onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                            >
                                                                 Next ➡️
                                                            </button>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </main>
               <CustomModal isOpen={showEditModal} onClose={() => setShowEditModal(false)}>
                    <h5 className="modal-title">Edit Attendance for {formData.doct_code}</h5>
                    <form onSubmit={handleEditAttendance}>
                         <div className="modal-body row">
                              <div className="form-group col-sm-12">
                                   <label htmlFor="date">Attendance Date</label>
                                   <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                              <div className="form-group col-sm-6">
                                   <label htmlFor="in_time">In Time</label>
                                   <input
                                        type="time"
                                        className="form-control form-control-sm"
                                        name="in_time"
                                        value={formData.in_time}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                              <div className="form-group col-sm-6">
                                   <label htmlFor="out_time">Out Time</label>
                                   <input
                                        type="time"
                                        className="form-control form-control-sm"
                                        name="out_time"
                                        value={formData.out_time}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                         </div>
                         <div className="modal-footer">
                              <button
                                   type="button"
                                   className="btn btn-sm btn-secondary mr-2"
                                   onClick={() => setShowEditModal(false)}
                              >
                                   Cancel
                              </button>
                              <button type="submit" className="btn btn-sm btn-primary">
                                   Save Changes
                              </button>
                         </div>
                    </form>
               </CustomModal>
               <CustomModal isOpen={showAddModal} onClose={() => setShowAddModal(false)}>
                    <h5 className="modal-title">Add New attendance for {formData.doct_code}</h5>
                    <form onSubmit={handleAddAttendance} >
                         <div className="modal-body row">
                              <div className="form-group col-sm-6">
                                   <label htmlFor="date">Attendance Date</label>
                                   <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                              <div className="form-group col-sm-6">
                                   <label>BMID</label>
                                   <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name="doct_code"
                                        value={formData.doct_code}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                              <div className="form-group col-sm-6">
                                   <label htmlFor="InTime">In Time</label>
                                   <input
                                        type="time"
                                        className="form-control form-control-sm"
                                        name="in_time"
                                        value={formData.in_time}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                              <div className="form-group col-sm-6">
                                   <label htmlFor="OutTime">Out Time</label>
                                   <input
                                        type="time"
                                        className="form-control form-control-sm"
                                        name="out_time"
                                        value={formData.out_time}
                                        onChange={handleInputChange}
                                        required
                                   />
                              </div>
                         </div>
                         <div className="modal-footer">
                              <button type="button" className="btn btn-sm btn-secondary mr-2" onClick={() => setShowAddModal(false)}>
                                   Cancel
                              </button>
                              <button type="submit" className="btn btn-sm btn-primary">
                                   Save
                              </button>
                         </div>
                    </form>
               </CustomModal>
          </div>
     );
};
export default DoctorAttendance;